<div class="mc-spring-board">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    <h3>Settings</h3>
    <span class="mc-fill-remaining-flex-space"></span>
    <button mat-icon-button tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-body">
    <p class="mc-form-title">Theme</p>
    <mat-radio-group [(ngModel)]="theme" (ngModelChange)="applyChange({ theme: $event })" class="mc-live-log-settings-dialog-radio-group">
      <mat-radio-button class="mat-accent-vivid" value="light">Light</mat-radio-button>
      <mat-radio-button class="mat-accent-vivid" value="dark">Dark</mat-radio-button>
    </mat-radio-group>

    <p class="mc-form-title">Timestamps</p>
    <mat-radio-group [(ngModel)]="timestampMode" (ngModelChange)="applyChange({ timestampMode: $event })" class="mc-live-log-settings-dialog-radio-group">
      <mat-radio-button class="mat-accent-vivid" value="none">None</mat-radio-button>
      <mat-radio-button class="mat-accent-vivid" value="local">Local</mat-radio-button>
      <mat-radio-button class="mat-accent-vivid" value="utc">UTC</mat-radio-button>
    </mat-radio-group>

    <div class="mc-form-field">
      <mat-checkbox color="accent-vivid" [(ngModel)]="showIcons" (ngModelChange)="applyChange({ showIcons: $event })">Show icons</mat-checkbox>
    </div>
  </div>
</div>
